var exports = {
  "vK": "xa15a2ab7--01636b--banner",
  "kZ": "xa15a2ab7--01636b--image-wrapper",
  "Qq": "xa15a2ab7--01636b--text",
  "s4": "xa15a2ab7--01636b--call-button-wrapper",
};

module.exports = exports;
